<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import DataTable from "datatables.net-vue3";

export default {
  page: {
    title: "Collection Batch Details",
    meta: [{ name: "description", content: appConfig.description }],
  },

  data() {
    return {
      role: localStorage.getItem("role"),
      title: "Collection Batch Details",
      items: [
        {
          text: "Collection Batch",
          href: "/",
        },
      ],

      rangeDateconfig: {
        mode: "range",
        dateFormat: "Y-m-d",
      },

      BatchListing: [],

      loadingRolesBatch: true,
      date: "",
      key_search: "",
      program_id: null,
      dtKey: 0,
      branchList: null,
      branch_id: null,

      modalContent: "",
      formattedModalContent: "",
      today: "",
      todayrange: "",
      collectionBatch: "",

      refNumber: "",
    };
  },

  methods: {
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
      return date;
    },

    downloadExcel: function () {
      //this.export_params = 'date='+this.date+'&key_search='+this.key_search+'&branch_id='+this.branch_id+'&program_id='+this.program_id;
      //location.href= process.env.VUE_APP_API_BASEURL+'customer/export/'+this.export_params;
      if (this.branch_id != null) {
        if (this.branch_id.length == 0) {
          this.branch_id = "";
        }
      }
      if (this.program_id != null) {
        if (this.program_id.length == 0) {
          this.program_id = "";
        }
      }
      const posting_ = {
        date: this.today,
        key_search: this.key_search,
        branch_id: this.branch_id,
        program_id: this.program_id,
      };

      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .post(process.env.VUE_APP_AR_API_BASEURL + "export/collectionListingExport", posting_, { responseType: "blob" })
        .then((response) => {
          if (response) {
            console.log(response);
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Collection List.xlsx");
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    CollectionBatchList() {
      this.loadingRolesBatch = true;

      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .get(process.env.VUE_APP_AR_API_BASEURL + "datatables/collections/" + this.$route.params.batchId)
        .then((response) => {
          console.log("batch-list", response);
          if (response) {
            this.loadingRolesBatch = false;
            this.BatchListing = response.data;
          } else {
            this.loadingRolesBatch = false;
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.loadingRolesBatch = false;
          this.messageBag = [error.error];
        });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, "0");
      this.today = `${year}-${month}-${day}`;
    },

    getRequestAmount(amount) {
      try {
        return parseFloat(amount).toFixed(2);

        // const requestObject = JSON.parse(requestString);
        // return requestObject.amount;
      } catch (error) {
        console.error("Invalid JSON string", error);
        return "N/A";
      }
    },
  },

  components: {
    Layout,
    PageHeader,
    DataTable,
  },

  mounted() {
    this.getCurrentDate();
    this.CollectionBatchList();
  },

  computed: {
    statusText() {
      try {
        const response = JSON.parse(this.item.respon);
        if (response && response.Status) {
          const status = JSON.stringify(response.Status);
          return status === '["201"]' ? "success" : "fail";
        }
        return "";
      } catch (e) {
        return "fail";
      }
    },
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-header border-bottom-dashed">
        <div class="row g-4 align-items-center"></div>
      </div>

      <!-- <div class="card-body border-bottom-dashed border-bottom">
        <div class="row g-3 justify-content-end">
          <div class="col-sm-auto">
            <div>
              <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3">
                <i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel
              </button>
            </div>
          </div>
        </div>
      </div> -->

      <div class="tab-content text-muted">
        <div class="card-body">
          <div class="live-preview">
            <div class="row align-items-center g-12">
              <div class="col-lg-12">
                <div v-if="loadingRolesBatch">
                  <div class="spinner-border text-success" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div v-else>
                  <div class="table-responsive">
                    <DataTable
                      :options="{ lengthChange: false, searching: false }"
                      :key="dtKey"
                      class="table table-striped table-nowrap mb-0"
                      id="example"
                    >
                      <thead class="table-secondary">
                        <tr>
                          <th>#.</th>
                          <th scope="col">Reference Number</th>
                          <th scope="col">Customer Name</th>
                          <th scope="col">Amount ({{ this.getCurrency() }})</th>
                          <th scope="col">Collection Batch</th>
                          <th scope="col">Collection Date</th>
                          <th scope="col">Collection Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in BatchListing" :key="index" class="content">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.refNum }}</td>
                          <td>{{ item.customer }}</td>
                          <td>{{ getRequestAmount(item.amount) }}</td>
                          <td>{{ item.batchId }}</td>
                          <td>{{ formatDate(item.collectionDate) }}</td>
                          <td>{{ item.status }}</td>
                        </tr>
                      </tbody>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
